var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomusiblanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.55 102.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-5 {\n        mask: url(#mask-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-11 {\n        mask: url(#mask-3);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-13 {\n        opacity: .21;\n      }\n\n      .cls-13, .cls-14, .cls-15 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-20 {\n        mask: url(#mask-5);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-22 {\n        mask: url(#mask-4);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-26 {\n        fill: none;\n      }\n\n      .cls-27 {\n        mask: url(#mask-6);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-32 {\n        mask: url(#mask-1);\n      }\n\n      .cls-33 {\n        mask: url(#mask);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-14 {\n        opacity: .2;\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-15 {\n        opacity: .45;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    width: 145.55,
    height: 102.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 43.87,
    y: 63.02,
    width: 0.3,
    height: 0.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M44.18,63.1c-.05-.01-.1-.03-.15-.04-.05-.01-.1-.03-.15-.04l.3,.08Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 634.45,
    y1: -883.22,
    x2: 634.62,
    y2: -883.22,
    gradientTransform: "translate(470.09 -243.04) rotate(90) scale(.48 -.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 43.87,
    y: 63.02,
    width: 0.3,
    height: 0.08,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 43.87,
    y: 63.02,
    width: 0.3,
    height: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 634.45,
    y1: -883.22,
    x2: 634.62,
    y2: -883.22,
    gradientTransform: "translate(470.09 -243.04) rotate(90) scale(.48 -.48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3b3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#636263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9e9fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c2c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 39.84,
    y: 30.8,
    width: 15.45,
    height: 32.42
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M50.6,32.52c-2.22-3.97-4.29,.22-4.29,.22,.04-.16-6.23,22.65-6.23,22.65-.92,3.33,.84,6.73,3.94,7.68,3.14,.77,6.4-1.25,7.31-4.58l3.95-14.36c-2.22-5.61-4.49-11.29-4.69-11.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 274.33,
    y1: 116.3,
    x2: 274.5,
    y2: 116.3,
    gradientTransform: "translate(-21762.12 -51412.1) rotate(90) scale(187.52 -187.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 39.17,
    y: 28.54,
    width: 16.12,
    height: 35.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 39.17,
    y: 28.54,
    width: 16.12,
    height: 35.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 274.33,
    y1: 116.3,
    x2: 274.5,
    y2: 116.3,
    gradientTransform: "translate(-21762.12 -51412.1) rotate(90) scale(187.52 -187.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#3b3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#636263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#848486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9e9fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c2c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 46.31,
    y: 20.85,
    width: 18.85,
    height: 28.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.47,47.68l3.7-9.11-5.19-12.97c-.55-2.71-2.95-4.76-5.82-4.76s-5.06,1.87-5.74,4.4c-.42,1.12-1.01,3.15-2.1,7.49,0,0,2.09-4.19,4.28-.25,.23,.37,3.4,8.35,5.94,14.75,.17,.25,2.96,4.19,4.94,.44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 271.11,
    y1: 122.24,
    x2: 271.28,
    y2: 122.24,
    gradientTransform: "translate(20171.14 44660.43) rotate(-90) scale(164.55 -164.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 46.31,
    y: 20.85,
    width: 18.85,
    height: 30.59,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 46.31,
    y: 20.85,
    width: 18.85,
    height: 30.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 271.11,
    y1: 122.24,
    x2: 271.28,
    y2: 122.24,
    gradientTransform: "translate(20171.14 44660.43) rotate(-90) scale(164.55 -164.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#535152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#828183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a3a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c2c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 86,
    y: 62.99,
    width: 0.3,
    height: 0.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M86.3,62.99c-.05,.01-.1,.03-.15,.04-.05,.02-.1,.03-.15,.04l.3-.08Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -127.28,
    y1: -555.66,
    x2: -127.11,
    y2: -555.66,
    gradientTransform: "translate(586.56 177.58) rotate(90) scale(.9 -.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 85.96,
    y: 62.84,
    width: 0.39,
    height: 0.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 86.02,
    y: 62.9,
    width: 0.27,
    height: 0.27,
    transform: "translate(-19.34 79.38) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -127.28,
    y1: -555.66,
    x2: -127.11,
    y2: -555.66,
    gradientTransform: "translate(586.56 177.58) rotate(90) scale(.9 -.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#403d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#626062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#7f7f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#979799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a9aaac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b6b7b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c2c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 74.96,
    y: 30.83,
    width: 15.38,
    height: 32.36
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M90.1,55.36s-6.2-22.63-6.19-22.58c0,0-2.06-4.22-4.28-.24-.14,.22-1.59,3.83-3.4,8.38l-1.27,3.35,3.89,14.18c.91,3.33,4.16,5.36,7.31,4.59,3.1-.94,4.86-4.34,3.95-7.67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 271.07,
    y1: 114.83,
    x2: 271.25,
    y2: 114.83,
    gradientTransform: "translate(-17893.78 -42403.4) rotate(90) scale(156.55 -156.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 57.34,
    y: 20.53,
    width: 51.3,
    height: 51.3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 64.85,
    y: 28.05,
    width: 36.27,
    height: 36.27,
    transform: "translate(-8.35 72.21) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 271.07,
    y1: 114.83,
    x2: 271.25,
    y2: 114.83,
    gradientTransform: "translate(-17893.78 -42403.4) rotate(90) scale(156.55 -156.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#403d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#626062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7f7f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#979799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a9aaac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b6b7b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c2c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 43.85,
    y: 63.12,
    width: 0.3,
    height: 0.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M44.15,63.21c-.05-.01-.1-.03-.15-.04-.05-.01-.1-.03-.15-.04l.3,.08Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 633.41,
    y1: -882.96,
    x2: 633.58,
    y2: -882.96,
    gradientTransform: "translate(469.94 -242.43) rotate(90) scale(.48 -.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 43.85,
    y: 63.12,
    width: 0.3,
    height: 0.08,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 43.85,
    y: 63.12,
    width: 0.3,
    height: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 633.41,
    y1: -882.96,
    x2: 633.58,
    y2: -882.96,
    gradientTransform: "translate(469.94 -242.43) rotate(90) scale(.48 -.48)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 39.82,
    y: 30.91,
    width: 15.45,
    height: 32.42
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M50.58,32.62c-2.22-3.97-4.29,.22-4.29,.22,.04-.16-6.23,22.65-6.23,22.65-.92,3.33,.84,6.73,3.94,7.68,3.14,.77,6.4-1.25,7.31-4.58l3.95-14.36c-2.22-5.61-4.49-11.29-4.68-11.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 274.32,
    y1: 116.3,
    x2: 274.5,
    y2: 116.3,
    gradientTransform: "translate(-21762.33 -51411.37) rotate(90) scale(187.52 -187.52)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 39.14,
    y: 28.65,
    width: 16.12,
    height: 35.29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 39.14,
    y: 28.65,
    width: 16.12,
    height: 35.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 274.32,
    y1: 116.3,
    x2: 274.5,
    y2: 116.3,
    gradientTransform: "translate(-21762.33 -51411.37) rotate(90) scale(187.52 -187.52)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.22,47.83h0s0,.01,0,.03v.23c.08,.87,.6,3.62,4.32,3.62,3.93,0,4.65-2.44,4.78-3.37l1.02-21.71s.86-5.61-5.42-5.61-5.7,5.61-5.7,5.61l1,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.74,58.45c0-2.82,2.24-4.77,4.77-4.77s4.76,1.95,4.76,4.77-2.29,4.77-4.76,4.77-4.77-1.95-4.77-4.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.18,63.09c-.05-.01-.1-.03-.15-.04-.05-.01-.1-.03-.15-.04l.3,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.3,63.02c-.05,.01-.1,.03-.15,.04-.05,.02-.1,.03-.15,.04l.3-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.1,55.38l-6.23-22.74c-1.06-4.23-1.6-6.23-2.01-7.34-.68-2.53-2.99-4.4-5.74-4.4-.53,0-1.04,.07-1.53,.2-1.46,.32-2.71,1.2-3.5,2.41-.12,.15-.68,1.09-.81,1.65,0,0-2.02,5.4-4.63,12.2l-.49,1.21-5.26-13.36c-1.15-3.15-3.5-4.36-5.8-4.36-2.75,0-5.06,1.87-5.74,4.4-.4,1.08-.92,3.01-1.93,7.04l-6.35,23.09c-.92,3.33,.84,6.73,3.94,7.68,3.14,.77,6.4-1.25,7.31-4.58l3.95-14.36c.43,1.1,.87,2.19,1.28,3.24,0,0,0,0,0,0,1.47,4.29,2.4,6.31,2.82,7.42,1.32,2.53,3.32,4.09,6.06,4.06,2.87-.03,4.76-2.17,5.77-4.82l3.73-9.74,3.89,14.2c.91,3.33,4.16,5.36,7.31,4.59,3.1-.94,4.86-4.34,3.95-7.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.87,
    y: 63.02,
    width: 0.3,
    height: 0.08
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 39.17,
    y: 28.54,
    width: 16.12,
    height: 35.29
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 46.31,
    y: 20.85,
    width: 18.85,
    height: 30.59
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 86.02,
    y: 62.9,
    width: 0.27,
    height: 0.27,
    transform: "translate(-19.34 79.38) rotate(-45)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 64.85,
    y: 28.05,
    width: 36.27,
    height: 36.27,
    transform: "translate(-8.35 72.21) rotate(-45)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 43.85,
    y: 63.12,
    width: 0.3,
    height: 0.08
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 39.14,
    y: 28.65,
    width: 16.12,
    height: 35.29
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomusiblanco);
export default __webpack_public_path__ + "static/media/logomusiblanco.a363394f9dc07c55b5171774b7715a5f.svg";
export { ForwardRef as ReactComponent };